<div class="confirm-reset-password">
  <div class="card">
    <form class="k-form k-form-md" [formGroup]="confirmResetPasswordForm">
      <div class="form-field">
        <div class="top">
          <span class="title"><b>Confirm Reset Password - AutoForm Cloud</b></span>
        </div>

        <div class="confirm-reset-password-box">
          <div>

            <kendo-formfield>
              <kendo-label [for]="username" text="Email"> </kendo-label>
              <kendo-textbox
                formControlName="username"
                #username
              >
              </kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="newPassword" text="New Password"> </kendo-label>
              <kendo-textbox
                formControlName="newPassword"
                type="password"
                #newPassword
              >
              </kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="confirmPassword" text="Confirm Password"> </kendo-label>
              <kendo-textbox
                formControlName="confirmPassword"
                type="password"
                #confirmPassword
              >
              </kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label [for]="confirmationCode" text="Confirmation Code"> </kendo-label>
              <kendo-textbox
                formControlName="confirmationCode"
                #confirmationCode
              >
              </kendo-textbox>
            </kendo-formfield>

            @if(errorMessage) {
              <af-form-error
                [message]="errorMessage"
              ></af-form-error>
            }

            <ul class="af-hints">
              <li [ngClass]="this.validatorErrors['required'] ? '' : 'af-valid'">Required</li>
              <li [ngClass]="this.validatorErrors['minlength'] ? '' : 'af-valid'">At least 12 characters</li>
              <li [ngClass]="this.validatorErrors['oneUppercaseCharacter'] ? '' : 'af-valid'">1 upper case letter</li>
              <li [ngClass]="this.validatorErrors['oneLowercaseCharacter'] ? '' : 'af-valid'">1 lower case letter</li>
              <li [ngClass]="this.validatorErrors['oneDigitCharacter'] ? '' : 'af-valid'">1 number</li>
              <li [ngClass]="this.validatorErrors['oneSpecialCharacter'] ? '' : 'af-valid'">1 special character</li>
              <li [ngClass]="this.validatorErrors['notAllowedCharacters'] ? 'af-invalid' : 'hide'">Not allowed characters</li>
              <li [ngClass]="this.validatorErrors['compareFields'] ? '' : 'af-valid'">New password and confirm password match</li>
            </ul>

            <div class="k-form-buttons">
              <button kendoButton (click)="confirmResetPassword()">
                SAVE
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
